import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[styxFenceDetailTitle]'
})
export class StyxFenceDetailTitleDirective {
    @HostBinding('class.fence-detail-title') className = true;

    constructor() {}
}
